module.exports = __webpack_public_path__ + "front/img/27_5.53875e82.png";